import React from 'react';
import { Wrapper, Title, ContainerFields, Label, Value, Fields, Values } from './styled';
import { get } from 'lodash';

const Result = ({ data }) => {
  const vulns = get(data, 'vulns', 0);
  const services = get(data, 'services', 0);
  const hosts = get(data, 'hosts', 0);
  const workspacesName = get(data, 'workspaceName', '');

  return (
    <Wrapper>
      <Title children={ workspacesName } />
      <ContainerFields>
        <Fields>
          <Label children='Vulnerabilities: ' />
          <Label children='Services: ' />
          <Label children='Assets: ' />
        </Fields>
        <Values>
          <Value children={ vulns } />
          <Value children={ services } />
          <Value children={ hosts } />
        </Values>
      </ContainerFields>
    </Wrapper>
  );
};

export default Result;
